import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './feature/App';
import { Provider } from 'react-redux';
import configureStore from './redux/configureStore';
import initialState from './redux/initialState';
import { PersistGate } from 'redux-persist/integration/react';
import LinearProgress from '@mui/material/LinearProgress';
import * as serviceWorker from './serviceWorker';

export const reduxStore = configureStore(initialState);

const container = document.getElementById('root');
const root = createRoot(container);

const render = (Component) => {
  root.render(
    <Provider store={reduxStore.store}>
      <PersistGate loading={<LinearProgress />} persistor={reduxStore.persistor}>
        <Component />
      </PersistGate>
    </Provider>,
  );
};

render(App);

if (module.hot) {
  module.hot.accept('./feature/App', () => {
    const NextApp = require('./feature/App').default;
    render(NextApp);
  });
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
